import { PAYROLL_FILTERS } from "../types/payrollFiltersTypes";

export const setPayrollFilters = (data: any) => {
  return {
    type: PAYROLL_FILTERS.PAYROLL_FILTERS_SET_SELECTED,
    payload: { ...data },
  };
};

export const clearPayrollFilters = () => {
  return {
    type: PAYROLL_FILTERS.PAYROLL_FILTERS_CLEAR_SELECTED,
  };
};
